import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { ILanguageSelectorProps } from '../types';
import { LanguageSelector } from '../LanguageSelector';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: ILanguageSelectorProps = elementAttributesToProps(domNode);

  return Promise.resolve(<LanguageSelector {...props} />);
};

export default rehydrator;
